import { gql } from '@apollo/client';

export const UPDATE_SORTING_LABOR_TEAM = gql`
    mutation UpdateSortingLaborTeam($input: UpdateSortingLaborTeamInput!) {
        updateSortingLaborTeam(input: $input)
    }
`;

export const BATCH_UPDATE_SORTING_LABOR_TEAM = gql`
    mutation BatchUpdateSortingLaborTeam($input: BatchUpdateSortingLaborTeamInput!) {
        batchUpdateSortingLaborTeam(input: $input) {
            successCount
            failedAccountIds
        }
    }
`;
